module.exports = __webpack_public_path__ + "media/images/talent/flow-image03-5bfdef1f6cdc3ed553ac3504c2d80fc8.png";